/**
 * @fileoverview POST handler for the "/apps/user_info/:user_identifier/cancel_single_user_deletion" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUserIdentifierCancelSingleUserDeletionCacheKeys } from "./constants";
import type { PostAppsUserInfoUserIdentifierCancelSingleUserDeletionProps } from "./types";

export const postAppsUserInfoUserIdentifierCancelSingleUserDeletion = reactQueryMutationAdapter(
  appsUserInfoUserIdentifierCancelSingleUserDeletionCacheKeys,
  (props: PostAppsUserInfoUserIdentifierCancelSingleUserDeletionProps): Promise<{}> => {
    return fetch(`/apps/user_info/${props.userIdentifier}/cancel_single_user_deletion`, "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
